import { UPDATE_LIST } from './reducer';

export const updateAction = list => ({
  type: UPDATE_LIST,
  list,
});

export const update = searchValue => async dispatch => {
  const params = searchValue ? `?search=${searchValue}` : '';
  const list = await fetch(`/provider/search-plans${params}`);

  await dispatch(updateAction(list));
};
